import { emailBlacklistValidator as sharedEmailBlacklistValidator } from '#shared/utils/formControls';

export const emailBlacklistValidator = (email?: string): boolean => {
  if (!email) {
    return true;
  }
  const emailBlacklist = ENVIRONMENT_VARIABLES.emailBlacklist || [];
  return sharedEmailBlacklistValidator(email, emailBlacklist);
};
